import React, { useState } from 'react';

import {
    CustomRowTableCellProps,
    DataTable,
    Header,
    Row,
    SelectableOptions
} from '@amzn/imdb-shared-meridian-components/components/DataTable';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Pagination from '@amzn/meridian/pagination';
import Text from '@amzn/meridian/text';

interface ListDataTableProps {
    headers: Header<string>[];
    rows: Row<string>[];
    itemsPerPage: number;
    showPaginationOptions?: boolean;
    customRowTableCell?: React.VFC<CustomRowTableCellProps<string>>;
    emptyTableText?: string;
    selectableOptions?: SelectableOptions;
}

export const TABLE_TEST_ID = 'listsTable';

export const ListDataTable: React.FC<ListDataTableProps> = (props: ListDataTableProps) => {
    const { headers, rows, customRowTableCell, selectableOptions, itemsPerPage } = props;
    const showPaginationOptions = props.showPaginationOptions ?? false;
    const emptyTableText = props.emptyTableText ?? 'Empty';

    const [currentPage, setCurrentPage] = useState<number>(1);
    const firstVisibleIndex = (currentPage - 1) * itemsPerPage;
    const lastVisibleIndex = rows.length < itemsPerPage ? rows.length : firstVisibleIndex + itemsPerPage;
    const numberOfPages = Math.ceil(rows.length / itemsPerPage);
    const lastVisibleList = Math.min(lastVisibleIndex, rows.length);

    return rows.length > 0 ? (
        <Column width='100%' data-testid={TABLE_TEST_ID}>
            {showPaginationOptions && (
                <Heading level={5}>{`Showing entries ${firstVisibleIndex + 1} to ${lastVisibleList} of ${
                    rows.length
                } total`}</Heading>
            )}
            <DataTable
                data={{ headers: headers, rows: rows.slice(firstVisibleIndex, lastVisibleIndex) }}
                selectableOptions={
                    selectableOptions && {
                        idFieldName: selectableOptions.idFieldName,
                        selected: selectableOptions.selected,
                        setSelected: selectableOptions.setSelected
                    }
                }
                CustomRowTableCell={customRowTableCell}
            />
            {showPaginationOptions && (
                <Pagination
                    showSkipArrows={true}
                    numberOfPages={numberOfPages}
                    onChange={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
        </Column>
    ) : (
        <Text type='h300'>{emptyTableText}</Text>
    );
};
